import { useFrame } from '@react-three/fiber';
import { Jute } from '..';

const BVHGenerationControllerComponent = () => {

	useFrame(() => {
		Jute.staticGeometryWorkerController.tick();
		Jute.bvhWorkerController.tick();
	})

	return null;
};

export default BVHGenerationControllerComponent;
